import htmlComponent from "htmlcomponent";

export default function (dom, opts) {
	let options = {

		hideCls: 'filter-out',
		fileDataSel: '[data-values]',
		fileDataTargetSel: '[data-values][data-filter-target]',
		filterInputSel: '.simple-filter__single-checkbox',
		downloadFileSel: '.downloads__grid-single',
		resultSel: '.result-count',
		...opts
	};

	const body = document.body;
	const button = body.querySelector('[data-result]');

	const filterSingle = Array.from(body.querySelectorAll(options.fileDataSel));
	const filterTargets = Array.from(body.querySelectorAll(options.fileDataTargetSel));
	const allFilters = Array.from(dom.querySelectorAll(options.filterInputSel));
	const files = Array.from(body.querySelectorAll(options.downloadFileSel));
	const showCount = Array.from(dom.querySelectorAll(options.resultSel));

	let filterValue = "";

	function init() {
		allFilters.forEach( (filter, index) => {
			const targets = filterTargets.filter(target => target.dataset.values.split(/,\s?/).includes(filter.value) && target.dataset.filterTarget === 'download');
			showCount[index].innerHTML = targets.length;
		});
		button.addEventListener('click', () => {
			const filters = allFilters.filter(filter => filter.checked);
			filters.forEach( filter => {
					applyFilter(filter.value);
			});
			if(filters.length === 0) {
				resetFilter()
			}
		})
	}

	function resetFilter() {
		filterSingle.forEach( filter => {
			filter.classList.remove(options.hideCls);
		})
	}

	function applyFilter(value) {
		let delay = 0;
		filterValue = value;
		filterSingle.forEach( filter => {
			// create array with filterable values - data-value
			const values = filter.dataset.values.split(/,\s*/);
			// search for current filter value
			const active = filterValue ? values.includes(filterValue) : true;
			filter.classList.add(options.hideCls);

			if (active) {
				setTimeout(()=> {
					filter.style.animationDelay = `${delay}ms`;
					 filter.classList.remove(options.hideCls);
					delay += 100;
				}, 0)
			}
		})
	}

	init()

}
